import {Component, forwardRef, Injector} from "@angular/core";
import {ColumnComponent} from "../../../framework/entity/grid/column.component";
import {EntityData} from "@fedeltapointofsale/data-client";
import {Markup_Type} from "../../markup/markup.data";
import {
    AbstractSingleSelectColumnComponent
} from "../../../framework/entity/edit/edit-grid/columns/abstract-single-select-column.component";

@Component({
    selector: "wbo-price-level-markup-single-select-column",
    templateUrl: "../../../framework/entity/edit/edit-grid/columns/single-select-column.component.html",
    providers: [
        {provide: ColumnComponent, useExisting: forwardRef(() => PriceLevelMarkupSingleSelectColumnComponent), multi: true}
    ]
})
export class PriceLevelMarkupSingleSelectColumnComponent extends AbstractSingleSelectColumnComponent {
    constructor(injector: Injector) {
        super(injector);

        this.buildData([
            {label: "wbo.price-level.markup-types.override", value: Markup_Type.OVERRIDE},
            {label: "wbo.price-level.markup-types.fixedMarkup", value: Markup_Type.FIXED_MARKUP},
            {label: "wbo.price-level.markup-types.fixedMarkdown", value: Markup_Type.FIXED_MARKDOWN},
            {label: "wbo.price-level.markup-types.percentMarkup", value: Markup_Type.PERCENT_MARKUP},
            {label: "wbo.price-level.markup-types.percentMarkdown", value: Markup_Type.PERCENT_MARKDOWN}
        ]);
        this.allowClearSelectionOption = true;
    }

    override getPlaceholder(entity: EntityData<any>): string {
        return "";
    }
}
